export const MATCH_FLOWS_TABLE_HEADER_COLUMNS = 6;
